export interface QaAccess {
  canAccess: boolean;
  canViewOrder: boolean;
  canEditNotes: boolean;
  isEligible: boolean;
}

export interface QaNote {
  taskId: number;
  taskDescription: string;
  requirementNumber: string | null;
  text: string;
  updatedAt: string;
  updatedBy: string;
}

export interface QaState {
  revision: number;
  isPending: boolean;
  reviewedAt: string | null;
  reviewedBy: string | null;
  notes: QaNote[];
}

export interface QaPendingOrder {
  orderNumber: string;
  revision: number;
  noteCount: number;
  qaNoteTexts: string[];
  updatedAt: string;
  closerId: number | null;
  closerName: string | null;
  closerEmail: string | null;
  latestPolicyNote: {
    text: string;
    createdAt: string;
    createdBy: string | null;
  } | null;
}

export const qaChecklistHref = (orderNumber: string) =>
  `/task-management/closingchecklist?order=${encodeURIComponent(orderNumber)}&qaOnly=true`;
